import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { FIRM, WHATSAPP_URL } from "../data/content";

export function FloatingActions() {
  return (
    <>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-button"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-40 group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-900/30 transition-transform duration-300 group-hover:scale-110">
          <MessageCircle size={26} fill="currentColor" />
        </span>
      </a>

      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-navy/97 backdrop-blur border-t border-white/10 grid grid-cols-3" data-testid="mobile-sticky-bar">
        <a
          href={`tel:${FIRM.phone1Raw}`}
          data-testid="mobile-sticky-call-button"
          className="flex flex-col items-center gap-1 py-3 text-white active:bg-white/10"
        >
          <Phone size={18} className="text-gold" />
          <span className="text-[11px] font-medium tracking-wide">Call Now</span>
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-whatsapp-button"
          className="flex flex-col items-center gap-1 py-3 text-white active:bg-white/10 border-x border-white/10"
        >
          <MessageCircle size={18} className="text-gold" />
          <span className="text-[11px] font-medium tracking-wide">WhatsApp</span>
        </a>
        <Link
          to="/contact"
          data-testid="mobile-sticky-book-button"
          className="flex flex-col items-center gap-1 py-3 text-white active:bg-white/10"
        >
          <CalendarCheck size={18} className="text-gold" />
          <span className="text-[11px] font-medium tracking-wide">Consult</span>
        </Link>
      </div>
    </>
  );
}
